<template>
  <div class="hy-list-box">
    <Header pageTitle="学术会议" />
    <div class="hy-list-tab">
      <span
        :class="tabActive === 999 ? 'tab-active' : ''"
        @click="tabChange(999)"
        >全部</span
      >
      <span :class="tabActive === 0 ? 'tab-active' : ''" @click="tabChange(0)"
        >未开始</span
      >
      <span :class="tabActive === 1 ? 'tab-active' : ''" @click="tabChange(1)"
        >会议中</span
      >
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="hy-list" v-if="loading || articleList.length > 0">
        <XshyItem
          class="hy-list-item"
          v-for="item in articleList"
          :key="item.id"
          :title="item.goodsName"
          :cover="item.albumPics"
          :beginTime="
            item.meetingStartTime.slice(0, 10).replace(RegExp('-', 'g'), '.')
          "
          :address="item.province + '-' + item.city"
          :type="item.meetingState"
          :price="item.goodsPrice | priceFormat"
          :open="item.open"
          :showType="true"
          @click.native="toDetail(item.meetingId, item.id, item.open)"
        />
      </div>
      <noneList noneType="hyList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "AttendConference",
  components: {
    Header,
    XshyItem,
    noneList,
  },
  data() {
    return {
      columnName: "",
      tabActive: 999,
      Params: {
        pageNum: 0,
        pageSize: 20,
        beginDateTime: "",
      },
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  filters: {
    priceFormat(priceList) {
      if (priceList.length > 1) {
        return `¥${priceList[0]}-${priceList[priceList.length - 1]}`;
      } else {
        return priceList[0] > 0 ? "¥" + priceList[0] : "免费";
      }
    },
  },
  created() {},
  methods: {
    // 触底加载
    onLoad() {
      this.Params.pageNum += 1;
      this.getList();
    },
    tabChange(type) {
      // 0==未开始 1==以开始/会议中 2==已结束 999===代表全部
      if (type === 999) {
        delete this.Params.meetingState;
      } else {
        this.Params.meetingState = type;
      }
      this.tabActive = type;
      this.Params.pageNum = 1;
      this.articleList = [];
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.Params.pageNum == 1) {
        this.Params.beginDateTime = this.$global.transferDate(new Date());
      }
      console.log(this.Params);
      const resp = await this.$apis.listServe.getSphyList(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.data.length < 20;
        this.articleList.push(...resp.data.data);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id, goodsId, open) {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
            open ? "&open=" + open : ""
          }`,
        "_self"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.hy-list-box {
  padding-top: 44px;
  padding-bottom: 20px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .hy-list-tab {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    padding-bottom: 5px;
    height: 45px;
    background-color: #fff;
    span {
      position: relative;
      padding-bottom: 7px;
      font-size: 15px;
      color: #333333;
      line-height: 21px;
    }
    .tab-active {
      color: #4a79f1;
      font-weight: 700;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -40%;
        width: 80%;
        height: 2px;
        border-radius: 2px;
        background-color: #397bf9;
      }
    }
  }
  .hy-list {
    .hy-list-item {
      margin: 12px auto;
      padding-bottom: 15px;
      width: 351px;
      // height: 275px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
    }
  }
}
</style>
